import { inject, Injectable } from "@angular/core";
import { ComparatorOperators, ConformanceToGiasSummaryField, ConformanceToGiasSummaryQueryComplexInput, ConformanceToGiasSummarySimpleQueryInput, DownloadSummaryGQL, DownloadSummaryQuery, GetSummaryGQL, GetSummaryQuery, OperatorInput, PagingInput } from "../../../graphql/generated";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class SummaryService {
    private GetSummaryGQL: GetSummaryGQL = inject(GetSummaryGQL);
    private DownloadSummaryGQL: DownloadSummaryGQL = inject(DownloadSummaryGQL)

    getSummary(campaignId: string, attestationId: string, parameters: any): Observable<GetSummaryQuery['getConformanceGIASAttestationSummary']> {
        const par = convertLazyLoadToComplex(parameters);
        return this.GetSummaryGQL.fetch({ campaignId, attestationId, page: par.page, query: par.query }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.getConformanceGIASAttestationSummary))
    }

    exportSummary(campaignId: string, attestationId: string, parameters: any, timeZone: string): Observable<DownloadSummaryQuery['downloadConformanceGIASAttestationSummaryExcel']> {
        const par = convertLazyLoadToComplex(parameters);
        return this.DownloadSummaryGQL.fetch({ campaignId, attestationId, query: par.query, timeZone }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.downloadConformanceGIASAttestationSummaryExcel))
    }
}

export function convertLazyLoadToComplex(parameters: any): { query?: ConformanceToGiasSummaryQueryComplexInput, page: PagingInput } {
    const query: ConformanceToGiasSummarySimpleQueryInput[] = [];

    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_SUMMARY[field as keyof typeof ENUM_SUMMARY] || [field]).forEach(key => {
                        const val: string[] = values;
                        query.push({
                            field: key as ConformanceToGiasSummaryField,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: (key === ConformanceToGiasSummaryField.GiasSummaryStandardRatingQualitative ? val?.map(v => String(v)?.replace(' ', '_')) : val)?.map(v => String(v)?.toLowerCase() === 'empty' ? null : v)
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query: query,
                    operator: OperatorInput.And
                }
            ]
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 10
        }
    }
}


export const ENUM_SUMMARY = {
    level: [ConformanceToGiasSummaryField.GiasSummaryStandardLevel],
    name: [ConformanceToGiasSummaryField.GiasSummaryStandardName],
    ratingQuantitative: [ConformanceToGiasSummaryField.GiasSummaryStandardRatingQuantitative],
    ratingQualitative: [ConformanceToGiasSummaryField.GiasSummaryStandardRatingQualitative]
}